import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { IAccessRightCoreFilter, ILightWeightObject } from '@fi-shared/models';
import { FiValuesComparison } from '@fi-shared/utils/fi-values-comparison';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { Subject } from 'rxjs';
import { FiChecklistModuleDiscardChangesDialogData } from '@fi-app/shared/checklist/fi-checklist-helper.service';

interface IChecklist2ScheduleRolesEditorDialogData {
    availableRoles: ILightWeightObject[];
    checklistScheduleAccessRightCoreFilter: IAccessRightCoreFilter;
}

@Component({
    selector: 'fi-checklist2-schedule-roles-editor-dialog',
    template: `
        <p>{{ 'checklist.schedule_access_roles_description' | fiAppText }}</p>

        <fi-access-rights-manual-selection-roles
            [(ngModel)]="selectedRoleIds"
            [accessRightCoreItems]="data.availableRoles"
            [items]="data.checklistScheduleAccessRightCoreFilter.Roles"
        />
    `,
    styleUrls: ['./roles-editor-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-schedule-roles-editor-dialog' },
    standalone: false,
})
export class FiChecklist2ScheduleRolesEditorDialogComponent
    extends FiDialogsContentBase<IChecklist2ScheduleRolesEditorDialogData, number[]>
    implements OnInit, OnDestroy
{
    selectedRoleIds: number[] = [];
    private fiValuesComparison: FiValuesComparison<number[]>;

    ngOnInit() {
        this.setServices();
        this.selectedRoleIds = [...this.data.checklistScheduleAccessRightCoreFilter.RoleIds];
        this.fiValuesComparison = new FiValuesComparison(() => this.selectedRoleIds);
        this.subscribeOnTransitionCloseDialog(this.fiDialogsService, this.ngOnDestroy$);
    }

    getNoButtonClickPromise(): Promise<{ canClose: boolean }> {
        return this.fiDialogsService.getCanCloseConfirmation(!this.fiValuesComparison.isChanged());
    }

    getResult(): number[] {
        return this.selectedRoleIds;
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    private fiDialogsService: FiDialogsService;
    private setServices() {
        this.fiDialogsService = this.injector.get(FiDialogsService);
    }
}
